import axios from "axios";
import store from "@/store";
import { commonUrl, commonUrl2 } from "./common";

const url = commonUrl;
// Axios 인스턴스 생성 (기본 설정)
const api = axios.create({
  baseURL: url, // API 기본 URL
  timeout: 10000, // 요청 타임아웃 설정
});
export const url2 = commonUrl2;
const api2 = axios.create({
  baseURL: url2, // API 기본 URL
  timeout: 100000, // 요청 타임아웃 설정
});

api2.interceptors.request.use(
  (config) => {
    const token = store.state.StoreToken;

    config.headers["Authorization"] = `Bearer ${token}`;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api2.interceptors.response.use(
  (response) => {
    if (response.headers.authorization) {
      let newtoken = response.headers.authorization.substring(7);

      store.state.StoreToken = newtoken;
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status == 401) {
      // alert("로그인 시간이 1분 이상 지났습니다. 재로그인 해주세요.");
      store.commit("clearSession");
      router.push("/");
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export const getCustCompany = (groupCd, storecd, positiontype) => {
  return api2.post("/MICRM/CRM20_005RPT.asmx/getCustCompany", {
    GROUP_CD: groupCd,
    STORE_CD: storecd,
    LNG_POSITION: positiontype,
  });
};
export const getCustCompany2 = (groupCd, storecd) => {
  return api2.post("/MICRM/CRM01_013INS.asmx/getCustCompany2", {
    GROUP_CD: groupCd,
    STORE_CD: storecd,
  });
};
/** CRM01_050INS — 직원후불 고객정보관리(신규) */
export const getCustCompany050 = (groupCd, storecd) => {
  return api2.post("/MICRM/CRM01_050INS.asmx/getCustCompany2", {
    GROUP_CD: groupCd,
    STORE_CD: storecd,
  });
};
/** 소속사 콤보 — 공통 (상단·하단 표기는 Vue에서 처리) */
export const getAffComp = (companyCd, groupCd, userId) => {
  return api2.post("/MICRM/CRM01_050INS.asmx/getAffComp", {
    COMP_CD: companyCd,
    GROUP_CD: groupCd,
    USER_ID: userId,
  });
};

/** getAffComp 응답 row → 콤보 옵션 (소속사: strAffCompCode/Name) */
export const toAffCompOption = (item) => ({
  value: String(item.strAffCompCode ?? ""),
  label: String(item.strAffCompName ?? ""),
});

/** 소속사 목록 → 상단(전체)/하단(선택) 콤보 옵션 구성 */
export const buildAffCompCombos = (list) => {
  const seen = new Set();
  const items = [];
  for (const row of list ?? []) {
    const opt = toAffCompOption(row);
    if (!opt.value || seen.has(opt.value)) continue;
    seen.add(opt.value);
    items.push(opt);
  }

  const single = items.length === 1;
  const multi = items.length > 1;

  return {
    singleLocked: single,
    topOptions: single
      ? items
      : multi
        ? [{ value: "0", label: "전체" }, ...items]
        : [],
    detailOptions: single
      ? items
      : multi
        ? [{ value: "", label: "선택" }, ...items]
        : [],
    topValue: single ? items[0].value : "0",
    detailValue: single ? items[0].value : "",
  };
};
export const getAccCust = (
  companyCd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6
) => {
  return api2.post("/MICRM/CRM01_013INS.asmx/getAccCust", {
    COMPANY_CD: companyCd,
    CARD_NO: cond,
    CUST_ID: cond2,
    CUST_NM: cond3,
    DEPT_NM: cond4,
    COMP_NM: cond5,
    REPORT_TYPE: cond6,
  });
};
export const getAccCust050 = (
  companyCd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  affCompCd
) => {
  return api2.post("/MICRM/CRM01_050INS.asmx/getAccCust", {
    COMPANY_CD: companyCd,
    CARD_NO: cond,
    CUST_ID: cond2,
    CUST_NM: cond3,
    DEPT_NM: cond4,
    COMP_NM: cond5,
    REPORT_TYPE: cond6,
    AFF_COMP_CD: affCompCd == null || affCompCd === "" ? "0" : String(affCompCd),
  });
};
export const getBelongCust = (custcode, searchword, type) => {
  return api2.post("/MICRM/CRM20_005RPT.asmx/getBelongCust", {
    CUST_CD: custcode,
    SEARCHWORD: searchword,
    TYPE: type,
  });
};
export const getBelongCustList = (custcode, custid, condvalue) => {
  return api2.post("/MICRM/CRM20_005RPT.asmx/getBelongCustList", {
    CUST_CD: custcode,
    CUST_ID: custid,
    COND_VALUE: condvalue,
  });
};
export const getBalancebyCust = (
  custcode,
  custid,
  condvalue,
  startdate,
  enddate
) => {
  return api2.post("/MICRM/CRM20_006RPT.asmx/getBalancebyCust", {
    CUST_CD: custcode,
    CUST_ID: custid,
    COND_VALUE: condvalue,
    START_DATE: startdate,
    END_DATE: enddate,
  });
};
export const getBalancebyCustAndDate = (
  custcode,
  custid,
  startdate,
  enddate,
  cond,
  cond2
) => {
  return api2.post("/MICRM/CRM20_007RPT.asmx/getBalancebyCustAndDate", {
    CUST_CD: custcode,
    CUST_ID: custid,
    START_DATE: startdate,
    END_DATE: enddate,
    COND: cond,
    COND2: cond2,
  });
};
export const getBalancebyReceipt = (
  custcode,
  custid,
  startdate,
  enddate,
  cond,
  groupcd,
  lngattr,
  storecd
) => {
  return api2.post("/MICRM/CRM20_009RPT.asmx/getBalancebyReceipt", {
    CUST_CD: custcode,
    CUST_ID: custid,
    START_DATE: startdate,
    END_DATE: enddate,
    COND: cond,
    GROUP_CD: groupcd,
    ATTR: lngattr,
    STORE_CD: storecd,
  });
};
export const getBelongCustListbyCorner = (
  groupcd,
  storecd,
  areacd,
  custid,
  custtype,
  cond
) => {
  return api2.post("/MICRM/CRM20_010RPT.asmx/getBelongCustListbyCorner", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    AREA_CD: areacd,
    CUST_ID: custid,
    CUST_TYPE: custtype,
    COND: cond,
  });
};
export const getBalancebyAccount = (storecd, custid) => {
  return api2.post("/MICRM/CRM20_012INS.asmx/getBalancebyAccount", {
    STORE_CD: storecd,
    CUST_ID: custid,
  });
};
export const getPrePaidbyAccount = (storecd, custid, sd, ed, cond) => {
  return api2.post("/MICRM/CRM20_013RPT.asmx/getPrePaidbyAccount", {
    STORE_CD: storecd,
    CUST_ID: custid,
    START_DATE: sd,
    END_DATE: ed,
    COND: cond,
  });
};
export const getReservedChangeHistory = (
  groupcd,
  storecd,
  startdate,
  enddate,
  cond,
  cond2
) => {
  return api2.post("/MICRM/CRM10_021RPT.asmx/getReservedChangeHistory", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    START_DATE: startdate,
    END_DATE: enddate,
    COND: cond,
    COND2: cond2,
  });
};
export const getReservedSearch = (
  groupcd,
  storecd,
  startdate,
  enddate,
  status,
  cond,
  cond2
) => {
  return api2.post("/MICRM/CRM10_022RPT.asmx/getReservedSearch", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    START_DATE: startdate,
    END_DATE: enddate,
    STATUS: status,
    COND: cond,
    COND2: cond2,
  });
};
export const getReservedSearchByDays = (
  groupcd,
  storecd,
  startdate,
  enddate
) => {
  return api2.post("/MICRM/CRM10_023RPT.asmx/getReservedSearchByDays", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    START_DATE: startdate,
    END_DATE: enddate,
  });
};
export const getReservedDetail = (groupcd, storecd, startdate, cond, cond2) => {
  return api2.post("/MICRM/CRM10_024RPT.asmx/getReservedDetail", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    START_DATE: startdate,
    COND: cond,
    COND2: cond2,
  });
};
export const getReservedDetail2 = (
  groupcd,
  storecd,
  startdate,
  cond,
  cond2
) => {
  return api2.post("/MICRM/CRM10_024RPT.asmx/getReservedDetail2", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    START_DATE: startdate,
    COND: cond,
    COND2: cond2,
  });
};
export const getReservedCustomorSearch = (
  groupcd,
  storecd,
  startdate,
  enddate,
  status,
  cond,
  cond2
) => {
  return api2.post("/MICRM/CRM10_025RPT.asmx/getReservedCustomorSearch", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    START_DATE: startdate,
    END_DATE: enddate,
    STATUS: status,
    COND: cond,
    COND2: cond2,
  });
};
export const getReservedTimeTable = (groupcd, storecd) => {
  return api2.post("/MICRM/CRM10_007INS_shy.asmx/getReservedTimeTable", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
  });
};
export const getReservedNum = (groupcd, storecd) => {
  return api2.post("/MICRM/CRM10_019INS.asmx/getReservedNum", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
  });
};
export const getReserveTeamTable = (groupcd, storecd) => {
  return api2.post("/MICRM/CRM10_020INS.asmx/getReserveTeamTable", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
  });
};
export const getCustInfo2 = (groupcd, option, word) => {
  return api2.post("/MICRM/CRM02_002RPT.asmx/getCustInfo2", {
    GROUP_CD: groupcd,
    OPTION: option,
    WORD: word,
  });
};
export const getCustRecord = (
  groupcd,
  searchNum,
  sdate,
  edate,
  cond,
  cond2
) => {
  return api2.post("/MICRM/CRM02_002RPT.asmx/getCustRecord", {
    GROUP_CD: groupcd,
    SEARCHNUM: searchNum,
    START_DATE: sdate,
    END_DATE: edate,
    COND: cond,
    COND2: cond2,
  });
};
export const getCustPointInfo = (groupcd, cond) => {
  return api2.post("/MICRM/CRM02_002RPT.asmx/getCustPointInfo", {
    GROUP_CD: groupcd,
    COND: cond,
  });
};
export const getReceiptDataDetail2 = (groupcd, storecd, receiptNo) => {
  return api2.post("/MICRM/CRM02_002RPT.asmx/getReceiptDataDetail2", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    RECEIPT_NO: receiptNo,
  });
};
export const getCustBuyList = (
  groupcd,
  jointype,
  teamcode,
  supervisor,
  storecd,
  sdate,
  edate,
  pointcls
) => {
  return api2.post("/MICRM/CRM03_002INS.asmx/getCustBuyList", {
    GROUP_CD: groupcd,
    JOIN_TYPE: jointype,
    TEAM_CD: teamcode,
    SUPERVISOR: supervisor,
    STORE_CD: storecd,
    START_DATE: sdate,
    END_DATE: edate,
    POINT_CLS: pointcls,
  });
};
export const saveReserveTimeTable = (
  groupcd,
  storecd,
  holiday,
  rsvtype,
  rsvtime,
  rsvhour,
  dtmrsvtime,
  lngactive,
  update
) => {
  return api2.post("/MICRM/CRM10_007INS_shy.asmx/saveReserveTimeTable", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    COND1: holiday,
    COND2: rsvtype,
    COND3: rsvtime,
    COND4: rsvhour,
    COND5: dtmrsvtime,
    COND6: lngactive,
    UPDATE: update,
  });
};
export const saveReserveNum = (
  groupcd,
  storecd,
  holiday,
  rsvtype,
  rsvtime,
  max,
  update
) => {
  return api2.post("/MICRM/CRM10_019INS.asmx/saveReserveNum", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    COND1: holiday,
    COND2: rsvtype,
    COND3: rsvtime,
    COND4: max,
    UPDATE: update,
  });
};
export const saveReserveTeamTable = (
  groupcd,
  storecd,
  cond1,
  cond2,
  cond3,
  cond4,
  update
) => {
  return api2.post("/MICRM/CRM10_020INS.asmx/saveReserveTeamTable", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    COND1: cond1,
    COND2: cond2,
    COND3: cond3,
    COND4: cond4,
    UPDATE: update,
  });
};
export const getInitDataCustPurchase = (groupcd) => {
  return api2.post("/MICRM/CRM03_012RPT.asmx/getInitDataCustPurchase", {
    GROUP_CD: groupcd,
  });
};
export const getCompanyforpay = (groupcd) => {
  return api2.post("/MICRM/CRM01_012INS.asmx/getCompanyforpay", {
    GROUP_CD: groupcd,
  });
};
export const getBasisOfEmpPay = (groupcd) => {
  return api2.post("/MICRM/CRM01_012INS.asmx/getBasisOfEmpPay", {
    COMP_CD: groupcd,
  });
};
export const getCustBuyAggList = (
  groupcd,
  storeCd,
  jointype,
  supervisor,
  teamCd,
  sdate,
  edate,
  level,
  reporttype
) => {
  return api2.post("/MICRM/CRM03_012RPT.asmx/getCustBuyAggList", {
    GROUP_CD: groupcd,
    STORE_CD: storeCd,
    JOIN_TYPE: jointype,
    SUPER: supervisor,
    TEAM: teamCd,
    SDATE: sdate,
    EDATE: edate,
    LEVEL: level,
    REPORT_TYPE: reporttype,
  });
};
export const getCustBuyDetailList = (
  groupcd,
  storeCd,
  jointype,
  supervisor,
  teamCd,
  sdate,
  edate,
  level,
  cond2
) => {
  return api2.post("/MICRM/CRM03_011RPT.asmx/getCustBuyDetailList", {
    GROUP_CD: groupcd,
    STORE_CD: storeCd,
    JOIN_TYPE: jointype,
    SUPER: supervisor,
    TEAM: teamCd,
    SDATE: sdate,
    EDATE: edate,
    LEVEL: level,
    COND2: cond2,
  });
};
export const getCustCardDisList = (
  groupcd,
  storeCd,
  jointype,
  teamCd,
  supervisor,
  sdate,
  edate,
  cond
) => {
  return api2.post("/MICRM/CRM03_004INS.asmx/getCustCardDisList", {
    GROUP_CD: groupcd,
    STORE_CD: storeCd,
    JOIN_TYPE: jointype,
    SUPER: supervisor,
    TEAM: teamCd,
    SDATE: sdate,
    EDATE: edate,
    COND: cond,
  });
};
export const getCustPointAnalyInfo = (
  groupcd,
  storeCd,
  sdate,
  edate,
  area,
  attr,
  team,
  supervisor,
  sex,
  sdate2,
  edate2,
  sdate3,
  edate3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond3
) => {
  return api2.post("/MICRM/CRM03_008RPT.asmx/getCustPointAnalyInfo", {
    GROUP_CD: groupcd,
    STORE_CD: storeCd,
    SDATE: sdate,
    EDATE: edate,
    AREA: area,
    JOINTYPE: attr,
    TEAM: team,
    SUPERVISOR: supervisor,
    SEX: sex,
    SDATE2: sdate2,
    EDATE2: edate2,
    SDATE3: sdate3,
    EDATE3: edate3,
    COND4: cond4,
    COND5: cond5,
    COND6: cond6,
    COND7: cond7,
    COND8: cond8,
    COND9: cond9,
    COND3: cond3,
  });
};

export const getInitCouponType = (groupcd) => {
  return api2.post("/MICRM/CRM03_009RPT.asmx/getInitCouponType", {
    GROUP_CD: groupcd,
  });
};
export const getInitCouponType2 = (groupcd) => {
  return api2.post("/MICRM/CRM11_013RPT.asmx/getInitCouponType2", {
    GROUP_CD: groupcd,
  });
};

export const getCustCouponAnalyInfo = (
  groupcd,
  storeCd,
  sdate,
  edate,
  area,
  attr,
  team,
  supervisor,
  sex,
  sdate2,
  edate2,
  sdate3,
  edate3,
  cond4,
  cond5,
  cond6
) => {
  return api2.post("/MICRM/CRM03_009RPT.asmx/getCustCouponAnalyInfo", {
    GROUP_CD: groupcd,
    STORE_CD: storeCd,
    SDATE: sdate,
    EDATE: edate,
    AREA: area,
    JOINTYPE: attr,
    TEAM: team,
    SUPERVISOR: supervisor,
    SEX: sex,
    SDATE2: sdate2,
    EDATE2: edate2,
    SDATE3: sdate3,
    EDATE3: edate3,
    COND4: cond4,
    COND5: cond5,
    COND6: cond6,
  });
};

export const getCustMenuAnalyInfo = (
  groupcd,
  storeCd,
  sdate,
  edate,
  area,
  attr,
  team,
  supervisor,
  sex,
  sdate2,
  edate2,
  sdate3,
  edate3,
  majorgroup,
  subgroup,
  menuname,
  cond,
  cond2,
  cond3
) => {
  return api2.post("/MICRM/CRM03_010RPT.asmx/getCustMenuAnalyInfo", {
    GROUP_CD: groupcd,
    STORE_CD: storeCd,
    SDATE: sdate,
    EDATE: edate,
    AREA: area,
    JOINTYPE: attr,
    TEAM: team,
    SUPERVISOR: supervisor,
    SEX: sex,
    SDATE2: sdate2,
    EDATE2: edate2,
    SDATE3: sdate3,
    EDATE3: edate3,
    MAJOR_GROUP: majorgroup,
    SUB_GROUP: subgroup,
    MENUNAME: menuname,
    COND: cond,
    COND2: cond2,
    COND3: cond3,
  });
};
export const getCustDisCountList = (groupcd, storeCd, sdate, edate, cond) => {
  return api2.post("/MICRM/CRM03_034INS.asmx/getCustDisCountList", {
    GROUP_CD: groupcd,
    STORE_CD: storeCd,
    SDATE: sdate,
    EDATE: edate,
    COND: cond,
  });
};

export const getCustomerInfo = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11,
  cond12,
  cond13,
  cond14,
  cond15,
  cond16,
  cond17,
  cond18,
  cond19,
  cond20,
  cond21,
  cond22,
  cond23,
  cond24,
  cond25,
  cond26,
  cond27,
  cond28,
  cond29,
  cond30,
  cond31,
  cond32,
  cond33,
  cond34,
  cond35,
  cond36,
  cond37,
  cond38,
  cond39,
  cond40,
  cond41,
  cond42
) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/getCustomerInfo", {
    GROUP_CD: cond,
    JOINTYPE: cond2,
    TEAM: cond3,
    SUPER: cond4,
    STORE_CD: cond5,
    CUST_NO: cond6,
    CARD_ID: cond7,
    CUSTNAME: cond8,
    JOINSTS: cond9,
    RESINO: cond10,
    BIRTHMM: cond11,
    BIRTHDD: cond12,
    MARRIED: cond13,
    SEX: cond14,
    JOBCLS: cond15,
    MOBILE: cond16,
    HOMETEL: cond17,
    HOMEADDR: cond18,
    ETCADDR: cond19,
    JOINFROM: cond20,
    JOINTO: cond21,
    FIRSTFROM: cond22,
    FIRSTTO: cond23,
    LASTFROM: cond24,
    LASTTO: cond25,
    SPOINT: cond26,
    SALEPOINT: cond27,
    RPOINT: cond28,
    REMPOINT: cond29,
    AAMT: cond30,
    ACTAMT: cond31,
    VCNT: cond32,
    VISITCNT: cond33,
    LEVEL: cond34,
    SMS: cond35,
    PRECD: cond36,
    SLEEPSTS: cond37,
    CUSTAGREE: cond38,
    MKTAGREEFROM: cond39,
    MKTAGREETO: cond40,
    SMSAGREEFROM: cond41,
    SMSAGREETO: cond42,
  });
};

export const getCustomerInfoCount = (
  cond, cond2, cond3, cond4, cond5, cond6, cond7, cond8, cond9, cond10,
  cond11, cond12, cond13, cond14, cond15, cond16, cond17, cond18, cond19,
  cond20, cond21, cond22, cond23, cond24, cond25, cond26, cond27, cond28,
  cond29, cond30, cond31, cond32, cond33, cond34, cond35, cond36, cond37, cond38,
  cond39, cond40, cond41, cond42
) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/getCustomerInfoCount", {
    GROUP_CD: cond, JOINTYPE: cond2, TEAM: cond3, SUPER: cond4,
    STORE_CD: cond5, CUST_NO: cond6, CARD_ID: cond7, CUSTNAME: cond8,
    JOINSTS: cond9, RESINO: cond10, BIRTHMM: cond11, BIRTHDD: cond12,
    MARRIED: cond13, SEX: cond14, JOBCLS: cond15, MOBILE: cond16,
    HOMETEL: cond17, HOMEADDR: cond18, ETCADDR: cond19,
    JOINFROM: cond20, JOINTO: cond21, FIRSTFROM: cond22, FIRSTTO: cond23,
    LASTFROM: cond24, LASTTO: cond25, SPOINT: cond26, SALEPOINT: cond27,
    RPOINT: cond28, REMPOINT: cond29, AAMT: cond30, ACTAMT: cond31,
    VCNT: cond32, VISITCNT: cond33, LEVEL: cond34, SMS: cond35,
    PRECD: cond36, SLEEPSTS: cond37, CUSTAGREE: cond38,
    MKTAGREEFROM: cond39, MKTAGREETO: cond40,
    SMSAGREEFROM: cond41, SMSAGREETO: cond42,
  });
};

export const getCustomerInfoExcel = (
  cond, cond2, cond3, cond4, cond5, cond6, cond7, cond8, cond9, cond10,
  cond11, cond12, cond13, cond14, cond15, cond16, cond17, cond18, cond19,
  cond20, cond21, cond22, cond23, cond24, cond25, cond26, cond27, cond28,
  cond29, cond30, cond31, cond32, cond33, cond34, cond35, cond36, cond37, cond38,
  cond39, cond40, cond41, cond42
) => {
  return api2.post(
    "/MICRM/CRM01_001INS.asmx/getCustomerInfoExcel",
    {
      GROUP_CD: cond, JOINTYPE: cond2, TEAM: cond3, SUPER: cond4,
      STORE_CD: cond5, CUST_NO: cond6, CARD_ID: cond7, CUSTNAME: cond8,
      JOINSTS: cond9, RESINO: cond10, BIRTHMM: cond11, BIRTHDD: cond12,
      MARRIED: cond13, SEX: cond14, JOBCLS: cond15, MOBILE: cond16,
      HOMETEL: cond17, HOMEADDR: cond18, ETCADDR: cond19,
      JOINFROM: cond20, JOINTO: cond21, FIRSTFROM: cond22, FIRSTTO: cond23,
      LASTFROM: cond24, LASTTO: cond25, SPOINT: cond26, SALEPOINT: cond27,
      RPOINT: cond28, REMPOINT: cond29, AAMT: cond30, ACTAMT: cond31,
      VCNT: cond32, VISITCNT: cond33, LEVEL: cond34, SMS: cond35,
      PRECD: cond36, SLEEPSTS: cond37, CUSTAGREE: cond38,
      MKTAGREEFROM: cond39, MKTAGREETO: cond40,
      SMSAGREEFROM: cond41, SMSAGREETO: cond42,
    },
    { responseType: "blob" }
  );
};

export const getCustInitData = (groupcd) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/getCustInitData", {
    GROUP_CD: groupcd,
  });
};

/** 가입경로 마스터 (crmJoinPathMst) — 체크박스 목록 */
export const getJoinPathMst = (groupCd) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/getJoinPathMst", {
    GROUP_CD: groupCd,
  });
};

/** @deprecated getJoinPathMst 사용 */
export const getJoinPathList = getJoinPathMst;

/** 고객 가입경로 조회 — usp_CRM01_001INS_getCustJoinPath */
export const getCustJoinPath = (groupCd, custNo) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/getCustJoinPath", {
    GROUP_CD: groupCd,
    CUST_NO: custNo,
  });
};

/** 고객 가입경로 저장 — usp_CRM01_001INS_setCustJoinPath (INTSTOPRSN과 분리) */
export const setCustJoinPath = (groupCd, custNo, userSeq, joinPathCds) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/setCustJoinPath", {
    GROUP_CD: groupCd,
    CUST_NO: custNo,
    USER_SEQ: userSeq,
    JOIN_PATH_CDS: joinPathCds ?? "",
  });
};

export const getCrmPolicy = (groupcd) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/getCrmPolicy", {
    GROUP_CD : groupcd,    
  });
};

/** 마케팅 수신동의 안내 알림톡 템플릿 (mstAlimTalkInfo lngMsgType=5) */
export const getMktConsentAlimTalkTemplate = (groupCd) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/getMktConsentAlimTalkTemplate", {
    GROUP_CD: groupCd,
  });
};

/** 마케팅 수신동의 안내 알림톡 발송 */
export const sendMktConsentAlimTalk = (groupCd, custNo, consentDate) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/sendMktConsentAlimTalk", {
    GROUP_CD: groupCd,
    CUST_NO: custNo,
    CONSENT_DATE: consentDate,
  });
};

export const updateCustomerInfo = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11,
  cond12,
  cond13,
  cond14,
  cond15,
  cond16,
  cond17,
  cond18,
  cond19,
  cond20,
  cond21,
  cond22,
  cond23,
  cond24,
  cond25,
  cond26,
  cond27,
  cond28,
  cond29,
  cond30,
  cond31,
  cond32,
  cond33,
  cond34,
  cond35,
  cond36,
  cond37,
  cond38,
  cond39,
  cond40,
  cond41,
  cond42,
  cond43,
  cond44,
  cond45
) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/updateCustomerInfo", {
    GROUP_CD: cond,
    STORE_CD: cond2,
    JOIN_STS: cond3,
    USER_SEQ: cond4,
    CUST_NO: cond5,
    CUST_NM: cond6,
    CUST_ENM: cond7,
    CUST_CLS: cond8,
    SEX: cond9,
    MARRIED: cond10,
    RESNO1: cond11,
    RESNO2: cond12,
    BLNSMS: cond13,
    BLNEMAIL: cond14,
    STRMOBILE: cond15,
    STREMAIL: cond16,
    STRHOMETEL: cond17,
    STRHOMEZIP: cond18,
    STRHOMEADDR1: cond19,
    STRHOMEADDR2: cond20,
    STRETCTEL: cond21,
    STRETCZIP: cond22,
    STRETCADDR1: cond23,
    STRETCADDR2: cond24,
    DMRECV: cond25,
    SDAY_CLS: cond26,
    JOB_CLS: cond27,
    STRCOMPANY: cond28,
    JOBRANK: cond29,
    STRDEPART: cond30,
    STRBIRTHYY: cond31,
    STRBIRTHMM: cond32,
    STRBIRTHDD: cond33,
    BLNSOLAR: cond34,
    WEDDINGYY: cond35,
    WEDDINGMM: cond36,
    WEDDINGDD: cond37,
    CUSTAGREE: cond38,
    INTLEVEL: cond39,
    STRREMARK: cond40,
    INTSTOPRSN: cond41,
    DTMMANIA: cond42,
    LNGPR_CD: cond43,
    SMSAGREEDATE: cond44,
    MKTAGREEDATE: cond45,
  });
};
export const insertCustomerInfo = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11,
  cond12,
  cond13,
  cond14,
  cond15,
  cond16,
  cond17,
  cond18,
  cond19,
  cond20,
  cond21,
  cond22,
  cond23,
  cond24,
  cond25,
  cond26,
  cond27,
  cond28,
  cond29,
  cond30,
  cond31,
  cond32,
  cond33,
  cond34,
  cond35,
  cond36,
  cond37,
  cond38,
  cond39,
  cond40,
  cond41,
  cond42,
  cond43,
  cond44,
  cond45,
  cond46
) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/insertCustomerInfo", {
    GROUP_CD: cond,
    STORE_CD: cond2,
    JOIN_STS: cond3,
    USER_SEQ: cond4,
    CUST_NO: cond5,
    CUST_NM: cond6,
    CUST_ENM: cond7,
    CUST_CLS: cond8,
    SEX: cond9,
    MARRIED: cond10,
    RESNO1: cond11,
    RESNO2: cond12,
    BLNSMS: cond13,
    BLNEMAIL: cond14,
    STRMOBILE: cond15,
    STREMAIL: cond16,
    STRHOMETEL: cond17,
    STRHOMEZIP: cond18,
    STRHOMEADDR1: cond19,
    STRHOMEADDR2: cond20,
    STRETCTEL: cond21,
    STRETCZIP: cond22,
    STRETCADDR1: cond23,
    STRETCADDR2: cond24,
    DMRECV: cond25,
    SDAY_CLS: cond26,
    JOB_CLS: cond27,
    STRCOMPANY: cond28,
    JOBRANK: cond29,
    STRDEPART: cond30,
    STRBIRTHYY: cond31,
    STRBIRTHMM: cond32,
    STRBIRTHDD: cond33,
    BLNSOLAR: cond34,
    WEDDINGYY: cond35,
    WEDDINGMM: cond36,
    WEDDINGDD: cond37,
    CUSTAGREE: cond38,
    INTLEVEL: cond39,
    STRREMARK: cond40,
    INTSTOPRSN: cond41,
    DTMMANIA: cond42,
    LNGPR_CD: cond43,
    CARD_ID: cond44,
    SMSAGREEDATE: cond45,
    MKTAGREEDATE: cond46,
  });
};

export const validCardNo = (cond, cond2) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/validCardNo", {
    GROUP_CD: cond,
    CARD_NO: cond2,
  });
};
export const deleteCustomors = (cond, cond2, cond3, cond4, cond5) => {
  return api2.post("/MICRM/CRM01_001INS.asmx/deleteCustomor", {
    GROUP_CDS: cond,
    CUST_NOS: cond2,
    CARD_ID: cond3,
    JOIN_STS: cond4,
    USERID: cond5,
  });
};
export const getCardChangeInfo = (
  groupCd,
  custNo,
  cardId,
  custNm,
  joinSts,
  mobile
) => {
  /** '' 는 프로시저에서 DEFAULT 와 다르게 동작할 수 있음 → 미사용 조건은 null */
  const nilStr = (v) => {
    if (v === undefined || v === null) return null;
    const s = String(v).trim();
    return s === "" ? null : s;
  };
  const group = String(groupCd ?? "").trim();
  return api2.post("/MICRM/CRM01_008INS.asmx/getCardChangeInfo", {
    GROUP_CD: group === "" ? null : group,
    CUST_NO: nilStr(custNo),
    CARD_ID: nilStr(cardId),
    CUST_NM: nilStr(custNm),
    JOIN_STS: nilStr(joinSts),
    MOBILE: nilStr(mobile),
  });
};
export const changeCardNo = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8
) => {
  return api2.post("/MICRM/CRM01_008INS.asmx/changeCardNo", {
    GROUP_CD: cond,
    STORE_CD: cond2,
    USER_SEQ: cond3,
    CUST_NO: cond4,
    CARD_OLD: cond5,
    CARD_NEW: cond6,
    CARD_RSN: cond7,
    REASON: cond8,
  });
};
export const getCardChangeList = (cond, cond2) => {
  return api2.post("/MICRM/CRM01_008INS.asmx/getCardChangeList", {
    GROUP_CD: cond,
    CUST_NO: cond2,
  });
};

export const getStopCustList = (cond, cond2, cond3, cond4) => {
  return api2.post("/MICRM/CRM01_009RPT.asmx/getStopCustList", {
    GROUP_CD: cond,
    CUST_NO: cond2,
    S_DATE: cond3,
    E_DATE: cond4,
  });
};
export const restoreCustomor = (cond, cond2, cond3) => {
  return api2.post("/MICRM/CRM01_009RPT.asmx/restoreCustomor", {
    GROUP_CD: cond,
    CUST_NO: cond2,
    USER_ID: cond3,
  });
};
export const getRegisterCustomer = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9
) => {
  return api2.post("/MICRM/CRM01_010RPT.asmx/getRegisterCustomer", {
    GROUP_CD: cond,
    STORE_CD: cond2,
    JOIN_TYPE: cond3,
    SUPERVISOR: cond4,
    TEAMCD: cond5,
    SDATE: cond6,
    EDATE: cond7,
    LEVEL: cond8,
    REPORT_TYPE: cond9,
  });
};
export const getMemberShipExpirePoint = (cond, cond2, cond3, cond4, cond5) => {
  return api2.post("/MICRM/CRM05_003RPT.asmx/getMemberShipExpirePoint", {
    GROUP_CD: cond,
    SDATE: cond2,
    EDATE: cond3,
    POINT: cond4,
    CUSTNO: cond5,
  });
};
export const getMemberShipExpirePoint2 = (cond, cond2, cond3, cond4, cond5) => {
  return api2.post("/MICRM/CRM05_004RPT.asmx/getMemberShipExpirePoint2", {
    GROUP_CD: cond,
    SDATE: cond2,
    EDATE: cond3,
    POINT: cond4,
    CUSTNO: cond5,
  });
};
export const getPointHistoryList = (cond, cond2, cond3) => {
  return api2.post("/MICRM/CRM05_007INS.asmx/getPointHistoryList", {
    GROUP_CD: cond,
    CUST_NO: cond2,
    CARD_ID: cond3,
  });
};
export const updateBonusPoint = (cond, cond2, cond3, cond4, cond5, cond6) => {
  return api2.post("/MICRM/CRM05_007INS.asmx/updateBonusPoint", {
    GROUP_CD: cond,
    STORE_CD: cond2,
    CUST_NO: cond3,
    USER_ID: cond4,
    POINT: cond5,
    POINT_RSN: cond6,
  });
};
export const mergeCard = (cond, cond2, cond3, cond4, cond5, cond6, cond7) => {
  return api2.post("/MICRM/CRM05_008INS.asmx/mergeCard", {
    GROUP_CD: cond,
    CUST_NO1: cond2,
    CUST_NO2: cond3,
    CARD_NO1: cond4,
    CARD_NO2: cond5,
    USER: cond6,
    REASON: cond7,
  });
};
export const getInitGftData = (cond) => {
  return api2.post("/MICRM/CRM65_001RPT.asmx/getInitGftData", {
    GROUP_CD: cond,
  });
};
export const getGftLedgerList = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10
) => {
  return api2.post("/MICRM/CRM65_001RPT.asmx/getGftLedgerList", {
    GROUP_CD: cond,
    START_DATE: cond2,
    END_DATE: cond3,
    CATEGORY: cond4,
    TYPE: cond5,
    STATUS: cond6,
    CARD_NO: cond7,
    CHECK: cond8,
    START_DATE2: cond9,
    END_DATE2: cond10,
  });
};
export const getGftLedgerTradeList = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8
) => {
  return api2.post("/MICRM/CRM65_002RPT.asmx/getGftLedgerTradeList", {
    GROUP_CD: cond,
    STORE_CDS: cond2,
    COND: cond3,
    COND2: cond4,
    START_DATE: cond5,
    END_DATE: cond6,
    COND3: cond7,
    LANG: cond8,
  });
};
export const getGftLedgerTradeAggList = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8
) => {
  return api2.post("/MICRM/CRM65_004RPT.asmx/getGftLedgerTradeAggList", {
    GROUP_CD: cond,
    STORE_CDS: cond2,
    COND: cond3,
    COND2: cond4,
    START_DATE: cond5,
    END_DATE: cond6,
    COND3: cond7,
    LANG: cond8,
  });
};

export const getDynamicGrid4 = (groupCd, count) => {
  return api2.post("/MICRM/CRM65_005RPT.asmx/getDynamicGrid4", {
    GROUP_CD: groupCd,
    COUNT: count,
  });
};
export const getGftList = (groupCd) => {
  return api2.post("/MICRM/CRM65_005RPT.asmx/getGftList", {
    GROUP_CD: groupCd,
  });
};
export const getGftCardStockList = (groupCd, cond, cond2, cond3, cond4) => {
  return api2.post("/MICRM/CRM65_005RPT.asmx/getGftCardStockList", {
    GROUP_CD: groupCd,
    STORE_CD: cond,
    START_DATE: cond2,
    END_DATE: cond3,
    COND: cond4,
  });
};
export const getGftLedgerCreateList = (groupCd, cond, cond2, cond3, cond4) => {
  return api2.post("/MICRM/CRM60_004INS.asmx/getGftLedgerCreateList", {
    GROUP_CD: groupCd,
    COND: cond,
    COND2: cond2,
    SDATE: cond3,
    EDATE: cond4,
  });
};
export const getGftLedgerSaleList = (groupCd, cond, cond2, cond3, cond4) => {
  return api2.post("/MICRM/CRM60_006INS.asmx/getGftLedgerSaleList", {
    GROUP_CD: groupCd,
    COND: cond,
    COND2: cond2,
    SDATE: cond3,
    EDATE: cond4,
  });
};
export const getCreditCompanyList = (groupCd, cond) => {
  return api2.post("/MICRM/CRM60_006INS.asmx/getCreditCompanyList", {
    GROUP_CD: groupCd,
    STORE_CD: cond,
  });
};

/** 판매등록 저장 전 검증 (Popup1) */
export const getGftStkSaleCheck = (groupCd, storeCd, cardFrom, cardTo) => {
  return api2.post("/MICRM/CRM60_006INS.asmx/getGftStkSaleCheck", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
    CARD_FROM: cardFrom,
    CARD_TO: cardTo,
  });
};

/** 증정등록 저장 전 검증 (Popup2) */
export const getGftPrsntCheck = (groupCd, cardFrom, cardTo) => {
  return api2.post("/MICRM/CRM60_006INS.asmx/getGftPrsntCheck", {
    GROUP_CD: groupCd,
    CARD_FROM: cardFrom,
    CARD_TO: cardTo,
  });
};

/** 증정등록 저장 (Popup2) */
export const setGftPrsnt = (
  groupCd,
  groupCust,
  custCd,
  saleDate,
  cardFrom,
  cardTo,
  empSale
) => {
  return api2.post("/MICRM/CRM60_006INS.asmx/setGftPrsnt", {
    GROUP_CD: groupCd,
    GROUP_CUST: groupCust,
    CUST_CD: custCd,
    DATE: saleDate,
    CARD_FROM: cardFrom,
    CARD_TO: cardTo,
    EMPSALE: empSale,
  });
};

/** 거래처그룹(strDiv=1) / 고객(strDiv=2) */
export const getGftCustGroup = (groupCd, lngGroup, strDiv) => {
  return api2.post("/MICRM/CRM60_006INS.asmx/getCustGroup", {
    GROUP_CD: groupCd,
    LNG_GROUP: lngGroup,
    STR_DIV: strDiv,
  });
};
export const saveNewGftCard = (
  groupCd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6
) => {
  return api2.post("/MICRM/CRM60_004INS.asmx/saveNewGftCard", {
    GROUP_CD: groupCd,
    COND: cond,
    COND2: cond2,
    DESIGN: cond3,
    CNT: cond4,
    DATE: cond5,
    EMP_CNT: cond6,
  });
};

/** LF 푸드(1871) 연번생성 — 기등록 상품권번호 조회 */
export const getGftValidChk = (groupCd, cardNoFrom, cardNoTo) => {
  return api2.post("/MICRM/CRM60_004INS.asmx/getGftValidChk", {
    GROUP_CD: groupCd,
    CARD_FROM: cardNoFrom,
    CARD_TO: cardNoTo,
  });
};

/** LF 푸드(1871) 연번생성 — from~to 저장 */
export const setGftCreate = (
  groupCd,
  category,
  gftType,
  cardNoFrom,
  cardNoTo,
  validateDate,
  createCnt,
  empCreate
) => {
  return api2.post("/MICRM/CRM60_004INS.asmx/setGftCreate", {
    GROUP_CD: groupCd,
    COND: category,
    COND2: gftType,
    CARD_FROM: cardNoFrom,
    CARD_TO: cardNoTo,
    DATE: validateDate,
    CNT: createCnt,
    EMP_CNT: empCreate,
  });
};

export const saveGftCardSaleEnroll = (
  groupCd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9
) => {
  return api2.post("/MICRM/CRM60_006INS.asmx/saveGftCardSaleEnroll", {
    GROUP_CD: groupCd,
    STORE_CD: cond,
    DATE: cond2,
    CARD_NO: cond3,
    CARD_NO_E: cond4,
    CCARD: cond5,
    BUYCODE: cond6,
    EMPSALE: cond7,
    STRCARD_NO: cond8,
    CARD_APPROVE_NO: cond9,
  });
};
export const cancelGftCardSale = (groupCd, cond, cond2, cond3, cond4) => {
  return api2.post("/MICRM/CRM60_006INS.asmx/cancelGftCardSale", {
    GROUP_CD: groupCd,
    STORE_CD: cond,
    DATE: cond2,
    APPROVE_NO: cond3,
    EMPSALE: cond4,
  });
};

export const getGftLedgerReleaseList = (groupCd, cond, cond2, cond3, cond4) => {
  return api2.post("/MICRM/CRM60_008INS.asmx/getGftLedgerReleaseList", {
    GROUP_CD: groupCd,
    STORE_CD: cond,
    SDATE: cond2,
    EDATE: cond3,
    STATUS: cond4,
  });
};

/** 출고등록 전 유효성 — 레거시 GetGftValidChk */
export const getGftReleaseValidChk = (
  groupCd,
  storeCd,
  status,
  cardNoFrom,
  cardNoTo
) => {
  return api2.post("/MICRM/CRM60_008INS.asmx/getGftReleaseValidChk", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
    STATUS: status,
    CARD_NO: cardNoFrom,
    CARD_NO_E: cardNoTo,
  });
};

/** 출고취소 전 유효성 — 레거시 GetGftCancleChk */
export const getGftReleaseCancelChk = (
  groupCd,
  status,
  cardNoFrom,
  cardNoTo
) => {
  return api2.post("/MICRM/CRM60_008INS.asmx/getGftReleaseCancelChk", {
    GROUP_CD: groupCd,
    STATUS: status,
    CARD_NO: cardNoFrom,
    CARD_NO_E: cardNoTo,
  });
};

export const saveGftCardReleaseEnroll = (
  groupCd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6
) => {
  return api2.post("/MICRM/CRM60_008INS.asmx/saveGftCardReleaseEnroll", {
    GROUP_CD: groupCd,
    STORE_CD: cond,
    STATUS: cond2,
    CARD_NO: cond3,
    CARD_NO_E: cond4,
    DATE: cond5,
    USERID: cond6,
  });
};
export const saveGftCardReleaseCancel = (
  groupCd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5
) => {
  return api2.post("/MICRM/CRM60_008INS.asmx/saveGftCardReleaseCancel", {
    GROUP_CD: groupCd,
    STATUS: cond,
    CARD_NO: cond2,
    CARD_NO_E: cond3,
    DATE: cond4,
    USERID: cond5,
  });
};

export const getGFTMaster = (groupCd) => {
  return api2.post("/MICRM/CRM60_009INS.asmx/getGFTMaster", {
    GROUP_CD: groupCd,
  });
};
export const getGFTMaster2 = (groupCd, cond) => {
  return api2.post("/MICRM/CRM60_009INS.asmx/getGFTMaster2", {
    GROUP_CD: groupCd,
    LNGGROUP: cond,
  });
};

export const saveGftCardClientEnroll = (
  groupCd,
  group,
  lngcode,
  strname,
  div,
  saveflag
) => {
  return api2.post("/MICRM/CRM60_009INS.asmx/saveGftCardClientEnroll", {
    GROUP_CD: groupCd,
    GROUP: group,
    LNGCODE: lngcode,
    STRNAME: strname,
    DIV: div,
    SAVEFLAG: saveflag,
  });
};
export const saveExcelDataGft = (
  groupCd,
  group,
  lngcode,
  strname,
  div,
  saveflag,
  cond,
  cond2
) => {
  return api2.post("/MICRM/CRM60_007INS.asmx/saveExcelDataGft", {
    GROUP_CD: groupCd,
    EMPNO: group,
    AMOUNT: lngcode,
    GFTCARDNO: strname,
    SALEDATE: div,
    FROMDATE: saveflag,
    TODATE: cond,
    SALESTORE: cond2,
  });
};

export const getPromoCouponList = (
  groupcd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5
) => {
  return api2.post("/MICRM/CRM11_006RPT.asmx/getPromoCouponList", {
    GROUP_CD: groupcd,
    CUST_NO: cond,
    COUPON_NO: cond2,
    SDATE: cond3,
    EDATE: cond4,
    COUPON_ID: cond5,
  });
};
export const saveExtendExpireDate = (
  groupcd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5
) => {
  return api2.post("/MICRM/CRM11_006RPT.asmx/saveExtendExpireDate", {
    GROUP_CD: groupcd,
    CUST_NO: cond,
    COUPON_NO: cond2,
    MEMBER_DIV: cond3,
    DATE: cond4,
    USER_ID: cond5,
  });
};
export const getSMSSendList = (
  groupcd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11,
  cond12
) => {
  return api2.post("/MICRM/CRM11_007RPT.asmx/getSMSSendList", {
    GROUP_CD: groupcd,
    STORE_CD: cond,
    JOIN_TYPE: cond2,
    TEAM_CODE: cond3,
    SUPERVISOR: cond4,
    STRYM: cond5,
    DATETYPE: cond6,
    SDATE: cond7,
    EDATE: cond8,
    STRHP: cond9,
    SENDRESULT: cond10,
    SMSTYPE: cond11,
    CALLBACK: cond12,
  });
};

export const getReceiptEventList = (
  groupcd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7
) => {
  return api2.post("/MICRM/CRM10_004RPT.asmx/getReceiptEventList", {
    GROUP_CD: groupcd,
    STORE_CD: cond,
    JOIN_TYPE: cond2,
    SUPERVISOR: cond3,
    TEAM_CODE: cond4,
    SDATE: cond5,
    EDATE: cond6,
    TYPE: cond7,
  });
};

export const getEventCouponList = (
  groupcd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5
) => {
  return api2.post("/MICRM/CRM11_013RPT.asmx/getEventCouponList", {
    GROUP_CD: groupcd,
    MOBILE: cond,
    COUPON_NO: cond2,
    SDATE: cond3,
    EDATE: cond4,
    TYPE: cond5,
  });
};
export const getEventCouponEnrollList = (groupcd) => {
  return api2.post("/MICRM/CRM22_001INS.asmx/getEventCouponEnrollList", {
    GROUP_CD: groupcd,
  });
};

export const saveExtendEventExpireDate = (groupcd, cond, cond2, cond3) => {
  return api2.post("/MICRM/CRM11_013RPT.asmx/saveExtendEventExpireDate", {
    GROUP_CD: groupcd,
    MOBILE: cond,
    COUPON_NO: cond2,
    DATE: cond3,
  });
};

export const getKakaoAlarmDetail = (
  groupcd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7
) => {
  return api2.post("/MICRM/CRM40_056RPT.asmx/getKakaoAlarmDetail", {
    GROUP_CD: groupcd,
    STORE_CD: cond,
    JOIN_TYPE: cond2,
    SUPERVISOR: cond3,
    TEAM_CODE: cond4,
    SDATE: cond5,
    EDATE: cond6,
    TYPE: cond7,
  });
};
export const getKakaoAlarmAgg = (
  groupcd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7
) => {
  return api2.post("/MICRM/CRM40_057RPT.asmx/getKakaoAlarmAgg", {
    GROUP_CD: groupcd,
    STORE_CD: cond,
    JOIN_TYPE: cond2,
    SUPERVISOR: cond3,
    TEAM_CODE: cond4,
    SDATE: cond5,
    EDATE: cond6,
    TYPE: cond7,
  });
};

export const getPromotionList = (groupcd, cond, cond2) => {
  return api2.post("/MICRM/CRM10_001INS.asmx/getPromotionList", {
    GROUP_CD: groupcd,
    PROMO_CD: cond,
    GRADE: cond2,
  });
};

export const getEventCouponDetail = (groupcd, cond, cond2) => {
  return api2.post("/MICRM/CRM22_001INS.asmx/getEventCouponDetail", {
    GROUP_CD: groupcd,
    COUPON_NO: cond,
    STORE_CD: cond2,
  });
};

export const getCouponGroup = (groupcd) => {
  return api2.post("/MICRM/CRM22_001INS.asmx/getCouponGroup", {
    GROUP_CD: groupcd,
  });
};
export const getStoreSearch = (groupcd, type, Name) => {
  return api2.post("/MICRM/CRM22_001INS.asmx/getStoreSearch", {
    GROUP_CD: groupcd,
    TYPE: type,
    NAME: Name,
  });
};
export const getMenuList3 = (groupcd, cond, cond2, cond3, cond4) => {
  return api2.post("/MICRM/CRM22_001INS.asmx/getMenuList3", {
    GROUP_CD: groupcd,
    MGROUP: cond,
    SGROUP: cond2,
    MENUCD: cond3,
    MENUNM: cond4,
  });
};
export const saveEventCoupon = (
  groupcd,
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11,
  cond12,
  cond13,
  cond14,
  cond15,
  cond16,
  cond17,
  cond18,
  cond19,
  cond20,
  cond21,
  cond22,
  cond23
) => {
  return api2.post("/MICRM/CRM22_001INS.asmx/saveEventCoupon", {
    GROUP_CD: groupcd,
    COUPON_CD: cond,
    COUPON_NM: cond2,
    APPLYTYPE: cond3,
    LNGTERM: cond4,
    FROMDATE: cond5,
    TODATE: cond6,
    DUPLIYN: cond7,
    COUPONGROUP: cond8,
    STYPE: cond9,
    COUPONNOTYPE: cond10,
    SMSSENDYN: cond11,
    SMSTYPE: cond12,
    SMSTITLE: cond13,
    SMSSENDER: cond14,
    SMSTEXT: cond15,
    SMSIMG: cond16,
    USER: cond17,
    MENU00: cond18,
    MENU10: cond19,
    MENU01: cond20,
    COUPONSTORE: cond21,
    CMENU00: cond22,
    CMENU01: cond23,
  });
};

export const getSenderList = (groupcd, cond) => {
  return api2.post("/MICRM/CRM22_001INS.asmx/getSenderList", {
    GROUP_CD: groupcd,
    STORE_CD: cond,
  });
};

export const saveEmployeeCustInfo = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6
) => {
  return api2.post("/MICRM/CRM01_013INS.asmx/saveEmployeeCustInfo", {
    COMP_CD: cond,
    CUST_ID: cond2,
    CARD_NO: cond3,
    NCARD_NO: cond4,
    CARD_S: cond5,
    USERID: cond6,
  });
};
export const saveEmployeeCustInfo050 = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6
) => {
  return api2.post("/MICRM/CRM01_050INS.asmx/saveEmployeeCustInfo", {
    COMP_CD: cond,
    CUST_ID: cond2,
    CARD_NO: cond3,
    NCARD_NO: cond4,
    CARD_S: cond5,
    USERID: cond6,
  });
};
export const deleteCustomors2 = (cond, cond2, cond3, cond4, cond5) => {
  return api2.post("/MICRM/CRM01_013INS.asmx/deleteCustomors2", {
    COMP_CD: cond,
    CUST_ID: cond2,
    CARD_NO: cond3,
    USERID: cond4,
    USERIP: cond5,
  });
};
export const deleteCustomors050 = (cond, cond2, cond3, cond4, cond5) => {
  return api2.post("/MICRM/CRM01_050INS.asmx/deleteCustomors2", {
    COMP_CD: cond,
    CUST_ID: cond2,
    CARD_NO: cond3,
    USERID: cond4,
    USERIP: cond5,
  });
};

export const saveCustomorsInfo = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11,
  cond12,
  cond13,
  cond14
) => {
  return api2.post("/MICRM/CRM01_013INS.asmx/saveCustomorsInfo", {
    COMP_CD: cond,
    CUST_ID: cond2,
    LIMITAMT: cond3,
    CUSTSTS: cond4,
    CARDSTS: cond5,
    CARDNO: cond6,
    CUSTNM: cond7,
    DEPTCD: cond8,
    DEPTNM: cond9,
    TELNOS: cond10,
    COMPCD: cond11,
    COMPNM: cond12,
    ADDRESS: cond13,
    USERID: cond14,
  });
};

export const saveCustomorsInfo050 = (
  companyCd,
  custId,
  limitAmt,
  custSts,
  cardSts,
  cardNo,
  custNm,
  deptCd,
  deptNm,
  telNos,
  compCd,
  address,
  userId
) => {
  return api2.post("/MICRM/CRM01_050INS.asmx/saveCustomorsInfo", {
    COMP_CD: companyCd,
    CUST_ID: custId,
    LIMITAMT: limitAmt,
    CUSTSTS: custSts,
    CARDSTS: cardSts,
    CARDNO: cardNo,
    CUSTNM: custNm,
    DEPTCD: deptCd,
    DEPTNM: deptNm,
    TELNOS: telNos,
    COMPCD: compCd,
    ADDRESS: address,
    USERID: userId,
  });
};

export const saveCustCompInfo = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11
) => {
  return api2.post("/MICRM/CRM01_012INS.asmx/saveCustCompInfo", {
    COMP_CD: cond,
    CUST_TP: cond2,
    LIMIT_GBN: cond3,
    LIMIT_AMT: cond4,
    RESET_PERIOD: cond5,
    RESET_DAY: cond6,
    APPDATE: cond7,
    STIME: cond8,
    ETIME: cond9,
    MODIFY: cond10,
    USERID: cond11,
  });
};

export const getCustomorInfo = (cond, cond2, cond3, cond4, cond5, cond6) => {
  return api2.post("/MICRM/CRM20_003INS.asmx/getCustomorInfo", {
    COMP_CD: cond,
    COND: cond2,
    COND2: cond3,
    COND3: cond4,
    COND4: cond5,
    COND5: cond6,
  });
};
export const getCardInfo2 = (cond, cond2, cond3) => {
  return api2.post("/MICRM/CRM20_003INS.asmx/getCardInfo2", {
    CUST_CD: cond,
    COND: cond2,
    COND2: cond3,
  });
};
export const checkCardNumbyAccount = (cond, cond2, cond3) => {
  return api2.post("/MICRM/CRM20_003INS.asmx/checkCardNumbyAccount", {
    CUST_CD: cond,
    COND: cond2,
    COND2: cond3,
  });
};

export const deleteCustomors3 = (custcode, custid, cond) => {
  return api2.post("/MICRM/CRM20_003INS.asmx/deleteCustomors3", {
    CUST_CD: custcode,
    CUST_ID: custid,
    COND: cond,
  });
};

export const saveCreditCustomer = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11,
  cond12,
  cond13,
  cond14,
  cond15,
  cond16,
  cond17,
  cond18,
  cond19,
  cond20,
  cond21,
  cond22,
  cond23,
  cond24,
  cond25,
  cond26
) => {
  return api2.post("/MICRM/CRM20_003INS.asmx/saveCreditCustomer", {
    USER_ID: cond,
    FLAG: cond2,
    SALECOMPCD: cond3,
    CUSTID: cond4,
    CUSTNAME: cond5,
    REGISTNO: cond6,
    TELNO: cond7,
    TELNO2: cond8,
    POSTTELNO: cond9,
    EMAIL: cond10,
    STRZIP: cond11,
    ADDRESS: cond12,
    ADDRESS2: cond13,
    REMARK: cond14,
    REGISTDATE: cond15,
    CUSTSTS: cond16,
    DIRECTER: cond17,
    DEALKIND: cond18,
    DEALTYPE: cond19,
    ACCSTS: cond20,
    DEPTCD: cond21,
    DEPTNM: cond22,
    BTYPE: cond23,
    BCUSTID: cond24,
    BCUSTNM: cond25,
    LIMITAMT: cond26,
  });
};

export const saveCreditCustomer2 = (
  cond,
  cond2,
  cond3,
  cond4,
  cond5,
  cond6,
  cond7,
  cond8,
  cond9,
  cond10,
  cond11,
  cond12,
  cond13,
  cond14,
  cond15,
  cond16,
  cond17,
  cond18,
  cond19,
  cond20,
  cond21,
  cond22,
  cond23,
  cond24,
  cond25,
  cond26
) => {
  return api2.post("/MICRM/CRM20_011INS.asmx/saveCreditCustomer2", {
    USER_ID: cond,
    FLAG: cond2,
    SALECOMPCD: cond3,
    CUSTID: cond4,
    CUSTNAME: cond5,
    REGISTNO: cond6,
    TELNO: cond7,
    TELNO2: cond8,
    POSTTELNO: cond9,
    EMAIL: cond10,
    STRZIP: cond11,
    ADDRESS: cond12,
    ADDRESS2: cond13,
    REMARK: cond14,
    REGISTDATE: cond15,
    CUSTSTS: cond16,
    DIRECTER: cond17,
    DEALKIND: cond18,
    DEALTYPE: cond19,
    ACCSTS: cond20,
    DEPTCD: cond21,
    DEPTNM: cond22,
    BTYPE: cond23,
    BCUSTID: cond24,
    BCUSTNM: cond25,
    LIMITAMT: cond26,
  });
};

export const saveNewCardNo = (
  compcd,
  custid,
  type,
  cardNo,
  cardSts,
  userid,
  flag
) => {
  return api2.post("/MICRM/CRM20_003INS.asmx/saveNewCardNo", {
    COMP_CD: compcd,
    CUST_ID: custid,
    TYPE: type,
    CARD_NO: cardNo,
    CARD_STS: cardSts,
    USER_ID: userid,
    FLAG: flag,
  });
};

export const getOperateStoreList = (groupCd, usertype, storeCd) => {
  return api2.post("/MICRM/CRM10_001INS.asmx/getOperateStoreList", {
    GROUP_CD: groupCd,
    USER_TYPE: usertype,
    STORE_CD: storeCd,
  });
};

export const getCrmMenuList = (groupCd, storeCd) => {
  return api2.post("/MICRM/CRM10_001INS.asmx/getCrmMenuList", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
  });
};

export const getCouponList = (groupCd) => {
  return api2.post("/MICRM/CRM10_001INS.asmx/getCouponList", {
    GROUP_CD: groupCd,
  });
};

export const saveMemberPromotion = (
  groupCd,
  storeCd,
  userid,
  promocd,
  promonm,
  sdate,
  edate,
  membershipdiv,
  campaign,
  remark,
  lnggrade,
  applystorecd,
  essentialcount,
  essentialcd,
  choicecd,
  choicecd2,
  couponcd,
  couponcd2,
  couponusestore,
  point,
  datecount,
  sizeupdailycnt,
  sizeupcd,
  applymenucd,
  appdown
) => {
  return api2.post("/MICRM/CRM10_001INS.asmx/saveMemberPromotion", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
    USER_ID: userid,
    PROMO_CD: promocd,
    PROMO_NM: promonm,
    SDATE: sdate,
    EDATE: edate,
    MEMBERSHIP: membershipdiv,
    CAMPAIGN: campaign,
    REMARK: remark,
    LNG_GRADE: lnggrade,
    APPLY_STORECD: applystorecd,
    ESSENTIAL_CNT: essentialcount,
    ESSENTIAL_CD: essentialcd,
    CHOICE_CD: choicecd,
    CHOICE_CD2: choicecd2,
    COUPON_CD: couponcd,
    COUPON_CD2: couponcd2,
    COUPONUSESTORE: couponusestore,
    POINT: point,
    DATE_COUNT: datecount,
    SIZE_DAILY_CNT: sizeupdailycnt,
    SIZEUP_CD: sizeupcd,
    APPLY_MENU_CD: applymenucd,
    APP_DOWN: appdown,
  });
};

export const getReceiptEventList2 = (groupCd) => {
  return api2.post("/MICRM/CRM21_004INS.asmx/getReceiptEventList2", {
    GROUP_CD: groupCd,
  });
};

export const getReceiptEventDetail = (groupCd, eventCd) => {
  return api2.post("/MICRM/CRM21_004INS.asmx/getReceiptEventDetail", {
    GROUP_CD: groupCd,
    EVENT_CD: eventCd,
  });
};

export const saveReceiptEvent = (
  groupCd,
  eventCd,
  eventnm,
  sdate,
  edate,
  eventamt,
  eventcust,
  eventcount,
  cutting,
  logo,
  reissue,
  header,
  body,
  footer,
  numbertype,
  userid,
  strmenu,
  strstore,
  rdomenuopt,
  issueopt,
  eventamtopt,
  custtype,
  amttype,
  eventweekday,
  stiem,
  etime,
  barcodetn,
  printopt,
  recissuetype,
  couponcd,
  coouponnm,
  applytype,
  term,
  sdate2,
  edate2,
  headshare,
  couponmenu,
  couponstore,
  couponlist,
  duplicateyn,
  coupongroup,
  discounttype,
  discountamt,
  servicetype,
  menu10,
  menu01
) => {
  return api2.post("/MICRM/CRM21_004INS.asmx/saveReceiptEvent", {
    GROUP_CD: groupCd,
    EVENT_CD: eventCd,
    EVENT_NM: eventnm,
    SDATE: sdate,
    EDATE: edate,
    EVENT_AMT: eventamt,
    EVENT_CUST: eventcust,
    EVENT_CNT: eventcount,
    CUTTING: cutting,
    LOGO: logo,
    REISSUE: reissue,
    HEADER: header,
    BODY: body,
    FOOTER: footer,
    NUM_TYPE: numbertype,
    USER_ID: userid,
    STRMENU: strmenu,
    STRSTORE: strstore,
    MENUOPT: rdomenuopt,
    ISSUEOPT: issueopt,
    EVENTAMTOPT: eventamtopt,
    CUSTTYPE: custtype,
    AMTTYPE: amttype,
    WEEKDAY: eventweekday,
    STIME: stiem,
    ETIME: etime,
    BARCODETN: barcodetn,
    PRINTOPT: printopt,
    RECISSUETYPE: recissuetype,
    COUPON_CD: couponcd,
    COUPON_NM: coouponnm,
    APPLY_TYPE: applytype,
    TERM: term,
    SDATE2: sdate2,
    EDATE2: edate2,
    HEADSHARE: headshare,
    COUPONMENU: couponmenu,
    COUPONSTORE: couponstore,
    COUPONLIST: couponlist,
    DUPLIYN: duplicateyn,
    COUPONGROUP: coupongroup,
    DISCOUNTTYPE: discounttype,
    DISCOUNTAMT: discountamt,
    SERVICETYPE: servicetype,
    MENU10: menu10,
    MENU01: menu01,
  });
};
export const getMemberShipList = (groupCd) => {
  return api2.post("/MICRM/CRM21_002INS.asmx/getMemberShipList", {
    GROUP_CD: groupCd,
  });
};

export const getMemberShipCouponDetail = (groupcd, storecd, couponcd) => {
  return api2.post("/MICRM/CRM21_002INS.asmx/getMemberShipCouponDetail", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    COUPON_CD: couponcd,
  });
};

export const saveMemberShipCoupon = (
  couponCd,
  couponnm,
  coupontype,
  amountrate,
  applytype,
  sdate,
  edate,
  sterm,
  eterm,
  groupcd,
  storecd,
  couponprefix,
  lngleng,
  lngcount,
  dupyn,
  smssendyn,
  smstitle,
  smssender,
  smstext,
  smsimg,
  smstiem,
  insertuser,
  applystoretype,
  smstype,
  sharetype,
  headshare,
  storeshare,
  benefityn,
  svctype,
  coupongroup,
  discounttype,
  notice,
  menu,
  menu2,
  menu3
) => {
  return api2.post("/MICRM/CRM21_002INS.asmx/saveMemberShipCoupon", {
    COUPON_CD: couponCd,
    COUPON_NM: couponnm,
    COUPON_TYPE: coupontype,
    AMT_RATE: amountrate,
    AP_TYPE: applytype,
    SDATE: sdate,
    EDATE: edate,
    STIME: sterm,
    ETIME: eterm,
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    COUPON_PREFIX: couponprefix,
    LNGLENG: lngleng,
    LNGCOUNT: lngcount,
    DUPYN: dupyn,
    SENDYN: smssendyn,
    SMSTITLE: smstitle,
    SMSSENDER: smssender,
    SMSTEXT: smstext,
    SMSIMG: smsimg,
    SMSTIME: smstiem,
    USER_ID: insertuser,
    APSTORE_TYPE: applystoretype,
    SMSTYPE: smstype,
    SHARETYPE: sharetype,
    HEADSHARE: headshare,
    STORESHARE: storeshare,
    BENEFITYN: benefityn,
    SVCTYPE: svctype,
    COUPONGROUP: coupongroup,
    DISTYPE: discounttype,
    NOTICE: notice,
    MENU1: menu,
    MENU2: menu2,
    MENU3: menu3,
  });
};

export const getGftCard = (groupCd, cardNo, gftcard) => {
  return api2.post("/MICRM/CRM60_010INS.asmx/getGftCard", {
    GROUP_CD: groupCd,
    CARD_NO: cardNo,
    GFT_CARD: gftcard,
  });
};
export const checkGftCard = (groupCd, cardNo, gftcard) => {
  return api2.post("/MICRM/CRM60_010INS.asmx/checkGftCard", {
    GROUP_CD: groupCd,
    CARD_NO: cardNo,
    GFT_CARD: gftcard,
  });
};
export const setWelFareCardNo = (groupCd, ocardNo, cardNo, gftcard) => {
  return api2.post("/MICRM/CRM60_010INS.asmx/setWelFareCardNo", {
    GROUP_CD: groupCd,
    CARD_NO: ocardNo,
    CARD_NO2: cardNo,
    GFT_CARD: gftcard,
  });
};
